var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.334 1.28539C5.21038 1.28539 1.05688 5.4389 1.05688 10.5625C1.05688 15.6861 5.21038 19.8396 10.334 19.8396C15.4576 19.8396 19.6111 15.6861 19.6111 10.5625C19.6111 5.4389 15.4576 1.28539 10.334 1.28539ZM0.333984 10.5625C0.333984 5.03965 4.81114 0.5625 10.334 0.5625C15.8568 0.5625 20.334 5.03965 20.334 10.5625C20.334 16.0854 15.8568 20.5625 10.334 20.5625C4.81114 20.5625 0.333984 16.0854 0.333984 10.5625Z",
    fill: "#6429CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4666 9.80475C10.885 9.80475 11.2242 10.1439 11.2242 10.5624V14.8049C11.2242 15.2233 10.885 15.5625 10.4666 15.5625C10.0482 15.5625 9.70898 15.2233 9.70898 14.8049V10.5624C9.70898 10.1439 10.0482 9.80475 10.4666 9.80475Z",
    fill: "#6429CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70898 6.3201C9.70898 5.90169 10.0482 5.5625 10.4666 5.5625H10.4772C10.8956 5.5625 11.2348 5.90169 11.2348 6.3201C11.2348 6.73851 10.8956 7.0777 10.4772 7.0777H10.4666C10.0482 7.0777 9.70898 6.73851 9.70898 6.3201Z",
    fill: "#6429CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPurple);
export default __webpack_public_path__ + "static/media/exclamation-purple.77ff8d3332b75b7a866532a68dccded4.svg";
export { ForwardRef as ReactComponent };